<!-- src/components/Home.vue -->

<template>
  <div>
    <header-component />
    <birdsGroomingBanner-component />
    <footer-component />
  </div>
</template>
<script>
import headerComponent from '../header/headerComponent.vue';
import birdsGroomingBannerComponent from '../birdsGrooming/birdsGroomingBannerComponent.vue';
import footerComponent from '../footer/footerComponent.vue';

export default {
  name: 'bookingComponent',
  components: {
    headerComponent,
    birdsGroomingBannerComponent,
    footerComponent,
  },
};
</script>
